// import { useState } from "react"
import { Button, Col, Descriptions, Form, Input, message, Row} from "antd"
import { useDispatch, useSelector } from "react-redux"
import { stepperMoving } from "../../stores/actions"
import { request } from "../../../../shared/src/apis"
import { errorMessage } from "../../utils/commonStringsConsts"
import { submitEarlySettlementPostApi } from "../../utils/apisConsts"
import { ISettlementFormValues, IStateInfo } from "../../utils/commonInterfaces"
import moment from "moment";
import { useState } from "react";
// import Spinner from "../../components/spinner"
export const SubmitEarlySettlement = () => {
    const dispatch = useDispatch()
    const info = useSelector((state: any) => state?.actionsReducer?.info) as IStateInfo
    const [form] = Form.useForm<ISettlementFormValues>()
    const [discountAmount, setDiscountAmount] = useState<number>(0)

    // Function to calculate discount amount
    const calculateDiscountAmount = (discountValue: string) => {
        const discount = parseFloat(discountValue);
        
        // Check if discount is valid
        if (isNaN(discount) || discount <= 0 || discount > 100 || !info?.futureRevenueEligibleForDiscount) {
            setDiscountAmount(0);
            return;
        }
        
        // Calculate discount amount
        const calculatedAmount = (discount / 100) * info?.futureRevenueEligibleForDiscount;
        setDiscountAmount(calculatedAmount);
    };

    const handleSubmitEarlySettlement = async (values: ISettlementFormValues) => {
        const requestData = {
            userID: info?.userID,
            discount: Number(values?.discount),
        }

        try {
            const apiData: any = await dispatch(
                request({
                    method: "POST",
                    url: submitEarlySettlementPostApi,
                    data: requestData,
                }),
            )

            const res = await apiData?.data

            if (res?.status === 200) {
                message.success(res?.message, 5)
                dispatch(stepperMoving(0))
                return
            }

            message.error(res?.message, 5)
        } catch (error) {
            message.error(errorMessage, 5)
        }
    }

    const descriptionItems = [
        { label: "User Id", value: info?.userID },
        { label: "User Dues", value: info?.userDues },
        { label: "Advance Payments", value: info?.advancePayments },
        { label: "Future Fees", value: info?.futureFees },
        { label: "Maximum Early Settlement Discount", value: info?.earlySettlementDiscount },
        { label: "Early Settlement Discount on Future Fees", value: info?.earlySettlementDiscountOnFutureFees },
        { label: "Future Revenue Eligible For Discount", value: info?.futureRevenueEligibleForDiscount },
        { label: "Selected Payment Cycle Company Id", value: info?.selectedCycle?.companyID },
        { label: "Selected Payment Cycle", value: info?.selectedCycle?.paymentCycle },
        { label: "Selected Payment Cycle PC", value: moment(info?.selectedCycle?.pc).format("YYYY-MM-DD") },
        { label: "Selected Payment Cycle Collection Due Date", value: moment(info?.selectedCycle?.collectionDueDate).format("YYYY-MM-DD") },
    ]


    return (
        <div className="flex flex-col">
            
                <Descriptions bordered className="py-2.5" >
                    {descriptionItems?.map((item, index) => (
                        <Descriptions.Item key={index} span={3} label={item?.label} className="p-2.5">
                            {item?.value}
                        </Descriptions.Item>
                    ))}
                </Descriptions>

            <div className="createEarlyPayment">

                <Form name="nest-messages" onFinish={handleSubmitEarlySettlement} form={form} className="mt-5">
                    <Row className="inputsRow">
                        <Col span='8'>
                            <label>Discount % <span>*</span></label>
                            <Form.Item
                                name="discount"
                                rules={[
                                    ({ getFieldValue }) => ({
                                        validator(_, value) {
                                            if (isNaN(value)) {
                                                return Promise.reject(new Error("Discount must be a number"));
                                            }
                                            if (value > 100) {
                                                return Promise.reject(new Error(`Amount cannot exceed 100%`));
                                            }
                                            if (value <= 0) {
                                                return Promise.reject(new Error(`Amount should be bigger than 0`));
                                            }
                                            return Promise.resolve();
                                        },
                                    }),
                                ]}
                            >
                                <Input 
                                    placeholder="Enter a discount" 
                                    min={0} 
                                    max={100}
                                    onChange={(e) => calculateDiscountAmount(e?.target?.value)}
                                />
                            </Form.Item>
                        </Col>
                        <Col span='8'>
                            <label>Actual Discount Amount</label>
                            <Form.Item>
                                <Input 
                                    value={discountAmount ? `${discountAmount?.toFixed(2)} SAR` : '0.00 SAR'} 
                                    readOnly 
                                    style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
                                />
                            </Form.Item>
                        </Col>
                        
                        <Col span='8' className="btnCol">
                            <Form.Item>
                                <Button type="primary" block htmlType="submit" style={{ display: 'flex', justifyContent: 'flex-end', width: 'fit-content' }}>
                                    Submit early settlement
                                </Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </div>
        </div>
    )
}